import types from './types';

export const initialState = {
  purchasePaymentResult: null,
  vatVerification: {
    isFetching: false,
    isVerified: false,
  },
  videoMobileCode: {
    activation: {
      data: {},
      error: 0,
      isFetching: false,
    },
    code: '',
    data: {},
    error: null,
    isFetching: false,
  },
  videoMobileLicense: {
    didInvalid: false,
    error: null,
    isFetching: false,
    prices: {
      data: null,
      didInvalid: false,
      error: null,
      isFetching: false,
    },
  },
};

const reducers = {
  [types.GET_VAT_VERIFICATION_REQUEST]: (state) => ({
    ...state,
    purchasePaymentResult: null,
    vatVerification: {
      ...state.vatVerification,
      isFetching: true,
    },
  }),

  [types.GET_VAT_VERIFICATION_SUCCES]: (state) => ({
    ...state,
    vatVerification: {
      ...state.vatVerification,
      isFetching: false,
      isVerified: true,
    },
  }),

  [types.GET_VAT_VERIFICATION_ERROR]: (state) => ({
    ...state,
    vatVerification: {
      ...state.vatVerification,
      isFetching: false,
      isVerified: false,
    },
  }),

  [types.GET_MOBILE_VIDEO_LICENSE_FAILURE]: (state, { error }) => ({
    ...state,
    videoMobileLicense: {
      ...state.videoMobileLicense,
      error,
      isFetching: false,
    },
  }),

  [types.GET_MOBILE_VIDEO_LICENSE_PRICES_SUCCESS]: (state, { payload }) => ({
    ...state,
    videoMobileLicense: {
      ...state.videoMobileLicense,
      prices: {
        data: payload,
        didInvalid: true,
        error: null,
        isFetching: false,
      },
    },
  }),

  [types.GET_MOBILE_VIDEO_LICENSE_PRICES_FAILURE]: (state, { error }) => ({
    ...state,
    videoMobileLicense: {
      ...state.videoMobileLicense,
      prices: {
        data: null,
        didInvalid: false,
        error,
        isFetching: false,
      },
    },
  }),

  [types.SET_PAYMENT_RESULT]: (state, { payload }) => ({
    ...state,
    purchasePaymentResult: payload,
  }),

  [types.VERIFY_ACTIVATION_CODE_REQUEST]: (state) => ({
    ...state,
    videoMobileCode: {
      ...initialState.videoMobileCode,
      isFetching: true,
    },
  }),

  [types.INVALIDATE_CODE_DATA]: (state) => ({
    ...state,
    videoMobileCode: initialState.videoMobileCode,
  }),

  [types.VERIFY_ACTIVATION_CODE_SUCCESS]: (state, { code, payload }) => ({
    ...state,
    videoMobileCode: {
      ...initialState.videoMobileCode,
      code,
      data: payload,
      isFetching: false,
    },
  }),

  [types.VERIFY_ACTIVATION_CODE_ERROR]: (state, { error }) => ({
    ...state,
    videoMobileCode: {
      ...initialState.videoMobileCode,
      error,
      isFetching: false,
    },
  }),

  [types.VERIFY_ACTIVATION_CODE_FAILURE]: (state, { error }) => ({
    ...state,
    videoMobileCode: {
      ...initialState.videoMobileCode,
      error,
      isFetching: false,
    },
  }),

  [types.ACTIVATE_ACTIVATION_CODE_REQUEST]: (state) => ({
    ...state,
    videoMobileCode: {
      ...state.videoMobileCode,
      activation: {
        ...initialState.videoMobileCode.activation,
        isFetching: true,
      },
    },
  }),

  [types.ACTIVATE_ACTIVATION_CODE_SUCCESS]: (state, { payload }) => ({
    ...state,
    videoMobileCode: {
      ...state.videoMobileCode,
      activation: {
        ...initialState.videoMobileCode.activation,
        data: payload,
        isFetching: false,
      },
    },
  }),

  [types.ACTIVATE_ACTIVATION_CODE_ERROR]: (state, { error }) => ({
    ...state,
    videoMobileCode: {
      ...state.videoMobileCode,
      activation: {
        ...initialState.videoMobileCode.activation,
        error: error.status,
        isFetching: false,
      },
    },
  }),
};

const reducer = (state = initialState, action = {}) => {
  if (reducers[action.type]) {
    return reducers[action.type](state, action);
  }
  return state;
};

export default reducer;
